import { fieldTypes } from '@constants/constant';
import { Field } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { PORTFOLIO_TYPE_CONSTS } from '@modules/edit-preference/components/portfolio/components/add-edit-portfolio-type/add-edit-portfolio-type.fields';
import { ALBUM_PORTFOLIO_CONSTS } from '@modules/edit-preference/components/portfolio/components/add-edit-album-portfolio/add-edit-album-portfolio.constants';

export const PODCAST_FREE_PREVIEW_LOCK = [
  {
    id: 0,
    label: 'No Free Preview'
  },
  {
    id: 30,
    label: '30 seconds'
  },
  {
    id: 60,
    label: '60 seconds'
  },
  {
    id: 120,
    label: '2 minutes'
  },
  {
    id: 300,
    label: '5 minutes'
  },
  {
    id: 600,
    label: '10 minutes'
  }
];

export const MUSIC_FREE_PREVIEW_LOCK = [
  {
    id: 0,
    label: 'No Free Preview'
  },
  {
    id: 15,
    label: '15 seconds'
  },
  {
    id: 30,
    label: '30 seconds'
  },
  {
    id: 60,
    label: '60 seconds'
  },
  {
    id: 120,
    label: '2 minutes'
  }
];

export const STEP_1_BASIC_INFO_CONSTS = {
  STEP_1_OF_3: ALBUM_PORTFOLIO_CONSTS.STEP_1_OF_3,
  STEP: 'STEP',
  OF: 'OF',
  BASIC_INFORMATION: ALBUM_PORTFOLIO_CONSTS.BASIC_INFORMATION,
  SECTION_TITLE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Album Information',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Series Information',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Video Series Information',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Collection Information'
  },
  INDIVIDUAL_SECTION_TITLE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Song Information',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Podcast Information',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Video Information',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Item Information'
  },
  NAME_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Album Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Podcast Series Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Video Series Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Collection Name'
  },
  // Individual item labels
  INDIVIDUAL_NAME_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Song Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Podcast Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Video Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Item Name'
  },
  // Album/Series cover image labels
  COVER_IMAGE_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Album Cover Image*',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Series Cover Image*',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Video Series Cover Image*',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Collection Cover Image*'
  },
  // Individual item cover image labels
  INDIVIDUAL_COVER_IMAGE_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Song Cover Image*',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Podcast Cover Image*',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Video Cover Image*',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Item Cover Image*'
  },
  // Album/Series cover image required messages
  COVER_IMAGE_REQUIRED_MESSAGE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Album Cover Image is required',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Series Cover Image is required',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Video Series Cover Image is required',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Collection Cover Image is required'
  },
  // Individual item cover image required messages
  INDIVIDUAL_COVER_IMAGE_REQUIRED_MESSAGE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Song Cover Image is required',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Cover Image is required',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Video Cover Image is required',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Item Cover Image is required'
  },
  // Album/Series description labels
  DESCRIPTION_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Album Description (Optional)',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Series Description (Optional)',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Video Series Description (Optional)',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Collection Description (Optional)'
  },
  // Individual item description labels
  INDIVIDUAL_DESCRIPTION_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Song Description (Optional)',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Description (Optional)',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Video Description (Optional)',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Item Description (Optional)'
  },
  // Album/Series name placeholders
  NAME_PLACEHOLDER: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Enter Album Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Enter Podcast Series Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Enter Video Series Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Enter Collection Name'
  },
  // Individual item name placeholders
  INDIVIDUAL_NAME_PLACEHOLDER: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Enter Song Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Enter Podcast Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Enter Video Name',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Enter Item Name'
  },
  // Album/Series description placeholders
  DESCRIPTION_PLACEHOLDER: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Enter Album Description',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Enter Podcast Series Description',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Enter Video Series Description',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Enter Collection Description'
  },
  // Individual item description placeholders
  INDIVIDUAL_DESCRIPTION_PLACEHOLDER: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Enter Song Description',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Enter Podcast Description',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Enter Video Description',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Enter Item Description'
  },
  FILE_EXTENSION_INFO:
    'Any JPG, JPEG, PNG, HEIC, HEIF, WEBP, AVIF and GIF up to 5MB',
  IMAGE_FILE_SIZE_LIMIT_MESSAGE: 'Image file size should not exceed 5MB',
  SELECT_FILE: 'SELECT FILE',
  DISTRIBUTION_METHOD_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'How will you Distribute this Album?',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'How will you Distribute this Podcast Series?',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'How will you Distribute this Video Series?',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Collection Details:'
  },
  AT_LEAST_ONE_DISTRIBUTION_REQUIRED:
    '* Please select at least one distribution method',
  DISTRIBUTE_THROUGH_DSP: 'Digital Service Providers (DSPs)',
  DISTRIBUTE_THROUGH_LINKS: 'Include links to purchase Collection Items',
  DISTRIBUTE_THROUGH_DIRECT_SALES: 'Direct Sales',
  LIST_SINGLE_COLLECTION_ITEMS: 'List Single Collection Items',
  DIRECT_SALES_INFO_MESSAGE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'This will allow you to upload your music and fans can purchase directly through your TopFan and white-label site.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'This will allow you to upload your podcast episodes and fans can purchase directly through your TopFan and white-label site.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'This will allow you to upload your videos and fans can purchase directly through your TopFan and white-label site.',
  },
  INDIVIDUAL_PRICING_OPTION_TITLE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Single Song Pricing Options',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Single Podcast Episode Pricing Options',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Single Video Pricing Options',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Single Item Pricing Options'
  },
  INDIVIDUAL_PRICING_OPTIONS_HINT: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'You can set pricing for this specific song, which will give the fan the option to purchase a song individually and/or the entire album.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'You can set pricing for this specific episode, which will give the fan the option to purchase an episode individually and/or the entire podcast series.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'You can set pricing for this specific video, which will give the fan the option to purchase a video individually and/or the entire series.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'You can set pricing for this specific item, which will give the fan the option to purchase an item individually and/or the entire collection.'
  },
  // Album/Series locking title labels
  LOCKING_TITLE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Album Direct Sales Locking Settings',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Podcast Series Direct Sales Locking Settings',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Video Series Direct Sales Locking Settings',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Item Direct Sales Locking Settings'
  },
  MASTER_LOCKING_HINT: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'These are settings to lock andd sell the entire Album. You can also optionally choose to sell single songs using the settings further down this page. If a fan purchases the Album level all current and future Songs in the Album will be unlocked.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'These are settings to lock and sell the entire Podcast Series. You can also optionally choose to sell single podcast episodes using the settings further down this page. If a fan purchases the Series level all current and future Episodes in the Series will be unlocked.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'These are settings to lock and sell the entire Video Series. You can also optionally choose to sell single videos using the settings further down this page. If a fan purchases the Series level all current and future Videos in the Series will be unlocked.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'These are settings to lock and sell the entire Item Series. You can also optionally choose to sell single items using the settings further down this page. If a fan purchases the Series level all current and future Items in the Series will be unlocked.'
  },
  INDIVIDUAL_PURCHASE_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Individual Purchase of Album',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Individual Purchase of Podcast Series',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Individual Purchase of Video Series',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Individual Purchase of Item Series'
  },
  ALBUM_INDIVIDUAL_LOCKING_TITLE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Single Song Price',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Single Episode Price',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Single Video Price',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'Single Item Price'
  },
  ALBUM_INDIVIDUAL_LOCKING_HINT: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Note this is the default price for single songs. You will have ability to override and set unique prices for each song later in setup process.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Note this is the default price for single episodes. You will have ability to override and set unique prices for each episode later in setup process.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Note this is the default price for single videos. You will have ability to override and set unique prices for each video later in setup process.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Note this is the default price for single items. You will have ability to override and set unique prices for each item later in setup process.'
  },
  // Free preview duration labels
  ENABLE_FREE_PREVIEW_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Enable Free Preview for all Album Songs',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Enable Free Preview for all Podcast Episodes',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Enable Free Preview for all Videos Series Episodes',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Enable Free Preview for all Items'
  },
  // Individual sales labels
  ENABLE_INDIVIDUAL_SALES_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Optional: Allow Fans to Purchase Single Songs',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Optional: Allow Fans to Purchase Single Podcast Episodes',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Optional: Allow Fans to Purchase Single Videos',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Optional: Allow Fans to Purchase Single Items'
  },
  // Free preview duration info messages
  FREE_PREVIEW_DURATION_INFO_MESSAGE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Set a default free preview duration that will apply to all songs in this album. You can override the default free preview duration in the settings for each single song.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Set a default free preview duration that will apply to all episodes in this podcast series. You can override the default free preview duration in the settings for each single episode.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Set a default free preview duration that will apply to all videos in this video series. You can override the default free preview duration in the settings for each single video.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Set a default free preview duration that will apply to all items in this portfolio. You can override the default free preview duration in the settings for each single item.'
  },
  // Individual sales info messages
  INDIVIDUAL_SALES_INFO_MESSAGE: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'This will allow you to sell single songs without the fan needing to purchase the entire album.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'This will allow you to sell single episodes without the fan needing to purchase the entire podcast series.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'This will allow you to sell single videos without the fan needing to purchase the entire video series.',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'This will allow you to sell single items without the fan needing to purchase the entire portfolio.'
  },
  // Step 1: Album/Series level restrict labels
  RESTRICT_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Restrict Ability to Purchase Album to:',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Restrict Ability to Purchase Podcast Series to:',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Restrict Ability to Purchase Video Series to:',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Restrict Ability to Purchase Portfolio to:'
  },
  // Step 1: Individual item restrict labels (for individual song/podcast sales within album)
  RESTRICT_LABEL_INDIVIDUAL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]:
      'Restrict Ability to Purchase Single Album Songs to:',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]:
      'Restrict Ability to Purchase Single Podcast Episodes to:',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]:
      'Restrict Ability to Purchase Single Videos Series to:',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]:
      'Restrict Ability to Purchase Single Items to:'
  },
  RELEASING_ON: 'Release Date (Optional):',
  YEAR_OPTION: 'Year',
  DATE_OPTION: 'Date',
  SELECT_YEAR: 'Select Year',
  RELEASE_TYPE_YEAR: 'year' as const,
  RELEASE_TYPE_DATE: 'date' as const,
  FREE_PREVIEW_LOCK: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: MUSIC_FREE_PREVIEW_LOCK,
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: PODCAST_FREE_PREVIEW_LOCK,
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: PODCAST_FREE_PREVIEW_LOCK,
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: PODCAST_FREE_PREVIEW_LOCK
  },
  EDIT: 'Edit',
  DOWNLOAD: 'Download',
  BADGE_GROUPS_HINT: 'If a Group(s) is selected in this list, only users belonging to that Group will see this item.',
};

export const getNameField = (
  portfolioType: string,
  isIndividual: boolean = false
): Field => {
  const type = portfolioType || PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM;

  // Use individual labels if it's an individual item, otherwise use album/series labels
  const nameLabel = isIndividual
    ? STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_NAME_LABEL[type] ||
      STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_NAME_LABEL[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ]
    : STEP_1_BASIC_INFO_CONSTS.NAME_LABEL[type] ||
      STEP_1_BASIC_INFO_CONSTS.NAME_LABEL[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ];

  const namePlaceholder = isIndividual
    ? STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_NAME_PLACEHOLDER[type] ||
      STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_NAME_PLACEHOLDER[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ]
    : STEP_1_BASIC_INFO_CONSTS.NAME_PLACEHOLDER[type] ||
      STEP_1_BASIC_INFO_CONSTS.NAME_PLACEHOLDER[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ];

  return {
    type: fieldTypes.TEXT,
    label: nameLabel,
    name: 'name',
    placeholder: namePlaceholder,
    class: 'col-12',
    autoComplete: 'off',
    validation: {
      required: {
        message: `${nameLabel} is required`
      },
      maxlength: {
        value: 70,
        message: 'Maximum 70 characters allowed'
      }
    },
    maxlength: 70
  } as Field;
};

export const getDescriptionField = (
  portfolioType: string,
  isIndividual: boolean = false
): Field => {
  const type = portfolioType || PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM;

  // Use individual labels if it's an individual item, otherwise use album/series labels
  const descriptionLabel = isIndividual
    ? STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_DESCRIPTION_LABEL[type] ||
      STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_DESCRIPTION_LABEL[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ]
    : STEP_1_BASIC_INFO_CONSTS.DESCRIPTION_LABEL[type] ||
      STEP_1_BASIC_INFO_CONSTS.DESCRIPTION_LABEL[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ];

  const descriptionPlaceholder = isIndividual
    ? STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_DESCRIPTION_PLACEHOLDER[type] ||
      STEP_1_BASIC_INFO_CONSTS.INDIVIDUAL_DESCRIPTION_PLACEHOLDER[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ]
    : STEP_1_BASIC_INFO_CONSTS.DESCRIPTION_PLACEHOLDER[type] ||
      STEP_1_BASIC_INFO_CONSTS.DESCRIPTION_PLACEHOLDER[
        PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
      ];

  const validation: any = {
    maxlength: {
      value: 500,
      message: 'Maximum 500 characters allowed'
    }
  };

  return {
    type: fieldTypes.TEXT_AREA,
    label: descriptionLabel,
    name: 'description',
    placeholder: descriptionPlaceholder,
    class: 'col-12',
    validation: validation,
    maxlength: 500
  } as Field;
};

/** Year range: 1850 to current year + 3 */
const RELEASE_YEAR_START = 1850;
const RELEASE_YEAR_ADVANCE = 3;

export const getYearOptions = (): number[] => {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  const endYear = currentYear + RELEASE_YEAR_ADVANCE;
  for (let i = RELEASE_YEAR_START; i <= endYear; i++) {
    years.push(i);
  }
  return years;
};

export const getYearDropdownOptions = (): Array<{
  label: string;
  value: string;
}> => {
  return getYearOptions().map((year) => ({
    label: year.toString(),
    value: year.toString()
  }));
};

/**
 * Get release year select field
 */
export const getReleaseYearField = (
  yearOptions: Array<{ label: string; value: string }>
): Field => {
  return {
    type: fieldTypes.SELECT,
    label: '',
    name: 'release_year',
    class: 'col-12',
    placeholder: STEP_1_BASIC_INFO_CONSTS.SELECT_YEAR,
    options: yearOptions,
    labelKey: 'label',
    valueKey: 'value'
  } as Field;
};

/**
 * Get release type year checkbox field
 */
export const getReleaseTypeYearField = (): Field => {
  return {
    type: fieldTypes.CHECKBOX,
    label: '',
    name: 'release_type_year',
    class: 'col-auto',
    options: [
      {
        label: STEP_1_BASIC_INFO_CONSTS.YEAR_OPTION,
        value: STEP_1_BASIC_INFO_CONSTS.RELEASE_TYPE_YEAR
      }
    ],
    labelKey: 'label',
    valueKey: 'value'
  } as Field;
};

/**
 * Get release type date checkbox field
 */
export const getReleaseTypeDateField = (): Field => {
  return {
    type: fieldTypes.CHECKBOX,
    label: '',
    name: 'release_type_date',
    class: 'col-auto',
    options: [
      {
        label: STEP_1_BASIC_INFO_CONSTS.DATE_OPTION,
        value: STEP_1_BASIC_INFO_CONSTS.RELEASE_TYPE_DATE
      }
    ],
    labelKey: 'label',
    valueKey: 'value'
  } as Field;
};

/**
 * Get distribute through DSP checkbox field
 */
export const getDistributeThroughDSPField = (portfolioType: string): Field => {
  return {
    type: fieldTypes.CHECKBOX,
    label: '',
    name: 'distributeThroughDSP',
    class: 'col-12',
    options: [
      {
        label: portfolioType === PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
            ? STEP_1_BASIC_INFO_CONSTS.DISTRIBUTE_THROUGH_LINKS
            : STEP_1_BASIC_INFO_CONSTS.DISTRIBUTE_THROUGH_DSP,
        value: true
      }
    ],
    labelKey: 'label',
    valueKey: 'value'
  } as Field;
};

/**
 * Get distribute through direct sales checkbox field
 */
export const getDistributeThroughDirectSalesField = (
  infoMessage: string,
  portfolioType: string
): Field => {
  return {
    type: fieldTypes.CHECKBOX,
    label: '',
    name: 'distributeThroughDirectSales',
    class: 'col-12',
    options: [
      {
        label:
          portfolioType === PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM
            ? STEP_1_BASIC_INFO_CONSTS.LIST_SINGLE_COLLECTION_ITEMS
            : STEP_1_BASIC_INFO_CONSTS.DISTRIBUTE_THROUGH_DIRECT_SALES,
        value: true
      }
    ],
    labelKey: 'label',
    valueKey: 'value',
    infoIconMessageLbl: infoMessage
  } as Field;
};
